import _Set from "@babel/runtime-corejs3/core-js/set";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import warn from "../warn.js";
const exclusiveTransforms = new _Set(['rotate', 'crop', 'smartCrop', 'fit']);

const includesAnyExclusiveTransforms = transformationParams => {
  var _context;

  return _someInstanceProperty(_context = _Object$keys(transformationParams)).call(_context, transform => exclusiveTransforms.has(transform));
};

const createTransformationQuery = function () {
  let {
    transformations,
    quality,
    pixelDensity = 1,
    ...transformationParams
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  const explicitOrdering = _Array$isArray(transformations);

  if (transformations && includesAnyExclusiveTransforms(transformationParams)) {
    warn('Included transformations prop with other transforms. These other transforms will be ignored.');
  }

  let normalizedTransformations = transformations;

  if (!normalizedTransformations) {
    // backwards compat
    normalizedTransformations = [transformationParams];
  } else if (!_Array$isArray(normalizedTransformations)) {
    normalizedTransformations = [normalizedTransformations];
  }

  const transformationStrings = _flatMapInstanceProperty(normalizedTransformations).call(normalizedTransformations, thisTransformation => {
    const {
      width = 'w',
      height = 'h',
      rotate,
      crop,
      smartCrop,
      fit
    } = thisTransformation;
    const sizingCommand = smartCrop ? 'sc' : 'rs';
    const transformationCommands = [];
    let actualWidth;
    let actualHeight;

    if (width === 'w') {
      actualWidth = width;
    } else {
      actualWidth = Math.ceil(width * pixelDensity);
    }

    if (height === 'h') {
      actualHeight = height;
    } else {
      actualHeight = Math.ceil(height * pixelDensity);
    }

    if (`${actualWidth}.${actualHeight}` !== 'w.h') {
      if (fit && sizingCommand === 'rs') {
        transformationCommands.push(`${sizingCommand}_${actualWidth}.${actualHeight}.fit`);
      } else {
        transformationCommands.push(`${sizingCommand}_${actualWidth}.${actualHeight}`);
      }
    }

    if (rotate) {
      transformationCommands.push(`rt_${rotate}`);
    }

    if (crop) {
      transformationCommands.push(`cr_${crop.join('.')}`);
    }

    return transformationCommands;
  });

  let transformationQuery = '';

  if (transformationStrings.length > 0) {
    transformationQuery += `~${transformationStrings.join('-')}`;
  }

  const queryParams = [];

  if (quality) {
    queryParams.push(`quality=${quality}`);
  }

  if (explicitOrdering) {
    queryParams.push(`ordering=explicit`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return [transformationQuery, queryString].join('');
};

export default createTransformationQuery;